import { IAccountCredit } from "./accountCredit.type"
import { AccountCredit } from "./accountCredit"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"

export interface IBillingAccountTransactionRaw {
  billing_account_id: number
  accepted_at: string | null
  created_dttm: string | null
  description: string | null
  reference: string | null
}

export interface IAccountCreditRaw {
  id: number
  created_user: string | null
  reference: string
  account_credit_reason_name: string
  billing_account_transaction: IBillingAccountTransactionRaw
}

export const AccountCreditParser: IParser<IAccountCredit, IAccountCreditRaw> = {
  toDomain: (data: IAccountCreditRaw) => {
    try {
      return new AccountCredit(
        data.id,
        data.reference,
        data.billing_account_transaction.reference ?? "",
        data.account_credit_reason_name,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
